import { render, staticRenderFns } from "./correctness_icon.vue?vue&type=template&id=86cdbff6&scoped=true&"
import script from "./correctness_icon.vue?vue&type=script&lang=ts&"
export * from "./correctness_icon.vue?vue&type=script&lang=ts&"
import style0 from "./correctness_icon.vue?vue&type=style&index=0&id=86cdbff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cdbff6",
  null
  
)

export default component.exports